<template>
  <b-container class="p-0 control-buttons-container">
    <b-row>
      <b-col
        v-if="data.link.status !== 1"
        :xl="data.link.status === 11 ? 4 : 6"
        lg="6"
        md="6"
        cols="12"
        class="buttons-container"
      >
        <b-button
          variant="info"
          target="_blank"
          @click="handleCopyLink"
        >
          Link de Pagamento
        </b-button>
      </b-col>
      <b-col
        v-if="data.link.status === 11"
        xl="4"
        lg="6"
        md="6"
        cols="12"
      >
        <b-button
          variant="danger"
          @click="handleCancelLink"
        >
          Cancelar Link
        </b-button>
      </b-col>
      <b-col
        :xl="data.link.status === 11 ? 4 : 6"
        lg="6"
        md="6"
        cols="12"
      >
        <b-button
          v-if="!data.link.status == 1"
          v-b-modal.modal-prevent-closing
          variant="secondary"
        >
          Reenvio de email
        </b-button>
      </b-col>
    </b-row>

    <b-row v-if="data.link.status === 1">
      <b-col
        xl="12"
        lg="12"
        md="12"
        cols="12"
        class="buttons-container"
      >
        <b-button
          variant="danger"
          target="_blank"
          @click="handleCancelRecurrence"
        >
          Cancelar Recorrência
        </b-button>
      </b-col>
    </b-row>

    <b-modal
      id="modal-prevent-closing"
      ref="my-modal"
      title="Reenviar Email"
      ok-title="Enviar"
      cancel-title="Cancelar"
      cancel-variant="outline-secondary"
      :ok-disabled="disabledBtnModal"
      @ok="handleResendMail"
    >
      <b-form
        ref="form"
      >
        <validation-observer
          ref="loginForm"
        >
          <validation-provider
            #default="{ errors }"
            name="Email"
            rules="required|email"
          >
            <b-form-group
              label="Email"
              label-for="Email"
            >
              <b-form-input
                id="Email"
                v-model="mail"
                required
                :state="errors.length > 0 ? false : null"
              />
              <small class="text-danger"> {{ errors[0] }}</small>
            </b-form-group>
          </validation-provider>
        </validation-observer>
      </b-form>
    </b-modal>

  </b-container>
</template>

<script>
import {
  BContainer,
  BButton,
  BCol,
  BRow,
  BModal,
  BFormGroup,
  BFormInput,
  BForm,
  VBModal,
} from 'bootstrap-vue'

import { ValidationProvider, ValidationObserver } from 'vee-validate'

import Ripple from 'vue-ripple-directive'

import { required } from '@validations'
import { cancelLink, cancelRecurrence, resendEmail } from '@/service/transaction/transaction'

import { callLoading } from '@/service/utilities/utilities'

export default {
  components: {
    BContainer,
    BButton,
    BCol,
    BRow,
    BModal,
    BFormGroup,
    BFormInput,
    ValidationProvider,
    ValidationObserver,
    BForm,
  },
  directives: {
    'b-modal': VBModal,
    Ripple,
  },
  props: ['type', 'data'],
  data() {
    return {
      link: '',
      mail: '',
      required,
      disabledBtnModal: false,
    }
  },
  watch: {
    mail(value) {
      const valid = /^([a-zA-Z0-9_\-\.]+)@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.)|(([a-zA-Z0-9\-]+\.)+))([a-zA-Z]{2,4}|[0-9]{1,3})$/
      this.disabledBtnModal = !valid.test(value)
    },
  },
  mounted() {
    const { hash } = this.data.link
    this.mail = this.data.customer.email
    this.link = this.type === 'payment-link' ? `${process.env.VUE_APP_URL}link-pagamento/1/${hash}` : `${process.env.VUE_APP_URL}link-recorrencia/1/${hash}`
  },
  methods: {
    async handleCancelRecurrence() {
      const confirm = await this.$bvModal
        .msgBoxConfirm('Você tem certeza que deseja cancelar essa recorrência?\ Essa ação é irreverssivel', {
          title: 'Por Favor Confirme',
          size: 'sm',
          okVariant: 'danger',
          okTitle: 'Cancelar Recorrência',
          cancelTitle: 'Voltar',
          cancelVariant: 'outline-secondary',
          hideHeaderClose: false,
          centered: true,
        }).then(value => value)

      if (confirm) {
        callLoading(true)
        const { id } = this.data.link
        try {
          const response = await cancelRecurrence(id)
          if (response) {
            await new Promise(resolve => setTimeout(resolve, 1000))
            location.reload()
          } else {
            this.$swal({
              title: 'Erro ao cancelar recorrência',
              icon: 'error',
              timer: 1000,
              showConfirmButton: false,
              buttonsStyling: false,
            })
          }
        } catch {
          this.$router.push('/error404')
        }
        callLoading(false)
      }
    },
    async handleCancelLink() {
      callLoading(true)
      const { id } = this.data.link
      if (await this.handleConfirmModal()) {
        try {
          this.renderPage = false
          const response = await cancelLink(id, this.type)
          if (response) {
            location.reload()
          }
        } catch {
          this.$router.push('/error404')
        }
      }
      callLoading(false)
    },

    async handleResendMail(event) {
      event.preventDefault()
      this.$nextTick(() => {
        this.$bvModal.hide('modal-prevent-closing')
      })
      const { hash } = this.data.link
      try {
        callLoading(true, true)
        const response = await resendEmail(hash, this.type, this.mail)
        const { status } = response
        this.handleEmailResponse(status === 200)
      } catch (err) {
        this.handleEmailResponse(false)
      } finally {
        callLoading(false)
      }
    },

    handleEmailResponse(isSuccess) {
      if (isSuccess) {
        this.$swal({
          title: 'Email enviado com sucesso',
          icon: 'success',
          timer: 1400,
          showConfirmButton: false,
          buttonsStyling: false,
        })
      } else {
        this.$swal({
          title: 'Não foi possível enviar o email',
          icon: 'error',
          timer: 1400,
          showConfirmButton: false,
          buttonsStyling: false,
        })
      }
    },

    async handleCopyLink() {
      navigator.clipboard.writeText(this.link)
      this.$swal({
        title: 'Link copiado com sucesso',
        icon: 'success',
        timer: 1400,
        showConfirmButton: false,
        buttonsStyling: false,
      })
    },

    async handleConfirmModal() {
      return this.$bvModal
        .msgBoxConfirm('Você tem certeza que deseja cancelar esse link?\ Essa ação é irreverssivel', {
          title: 'Por Favor Confirme',
          size: 'sm',
          okVariant: 'danger',
          okTitle: 'Cancelar Link',
          cancelTitle: 'Voltar',
          cancelVariant: 'outline-secondary',
          hideHeaderClose: false,
          centered: true,
        }).then(value => value)
    },
  },
}

</script>

<style lang="scss" scoped>
  .container {
    .control-buttons-container{
      margin-bottom: 2rem;

      button,a{
        width: 100%;
        margin-top: 0.5rem;
      }
    }
  }
</style>
